module.exports = __webpack_public_path__ + "5342bcbcdf5ea0bca85b7bc1a68d8632.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/giant-bow-blue.png
// module id = 2205
// module chunks = 0